import { getModelObj } from './spotBookingAccessors';
import type { SpotBookingBookingLike } from './types';

export const SPOT_BOOKING_CATEGORY_ID = '644681a04c68b64891f7b1c7';

export function isSpotBookingEnabledForBookingDetails(details: SpotBookingBookingLike): boolean {
  const modelObj = getModelObj(details);
  const isClass = details.model === 'event' || modelObj?.type === 'event';
  if (!isClass) return false;
  const categories = modelObj?.program_obj?.categories ?? [];
  return categories.includes(SPOT_BOOKING_CATEGORY_ID);
}
